
<div class="success-container">
    <div class="padded-container">
        <img src="assets/svg/check.svg" width="100px" />
        <h4 class="text-center mt-3">Success!</h4>
        <div class="row mt-4">
            <p class="ts">Payment Received <img src="assets/svg/check-sm.svg" width="23px"  alt=""/></p>
            <p class="ts">Payment Validated <img src="assets/svg/check-sm.svg" width="23px"  alt=""/></p>
            <p class="ts">Payment Acknowledged <img src="assets/svg/check-sm.svg" width="23px"  alt=""/></p>
        </div>
        <div class="button-section">
            <button (click)="downloadPaymentReceipt()">
                <svg width="30" height="30" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.99134 13.3306L6.00139 9.16717L7.11857 7.95978L9.19335 10.1248V3.33838H10.7893V10.1248L12.8641 7.95978L13.9813 9.16717L9.99134 13.3306ZM3.60742 16.6613V12.4979H5.2034V14.996H14.7793V12.4979H16.3753V16.6613H3.60742Z" fill="white"/>
                </svg>
                &nbsp;
                Download Receipt
            </button>
        </div>
    </div>
</div>